let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i4oFC")).then(() => parcelRequire('hjOit'));